export default function () {
  return {
    claims: [],
    claimsLoading: false,
    selectedStatus: undefined,
    claimSaving: false,
    claimFilesSaving: false
  };
}
